import { createContext, useContext, type ReactNode } from "react";

type TabBarOverrideSetter = (node: ReactNode | null) => void;

type TabBarOverrideContextValue = {
  setOverride: TabBarOverrideSetter;
  openChat: () => void;
};

const TabBarOverrideContext = createContext<TabBarOverrideContextValue>({
  setOverride: () => {},
  openChat: () => {},
});

export function TabBarOverrideProvider({
  children,
  setOverride,
  openChat,
}: {
  children: ReactNode;
  setOverride: TabBarOverrideSetter;
  openChat: () => void;
}) {
  return (
    <TabBarOverrideContext.Provider value={{ setOverride, openChat }}>
      {children}
    </TabBarOverrideContext.Provider>
  );
}

export function useTabBarOverride() {
  return useContext(TabBarOverrideContext).setOverride;
}

export function useMainChatOpener() {
  return useContext(TabBarOverrideContext).openChat;
}
